// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 200;
  }
  .dot {
    width: 24px;
    height: 24px;
    background: #3ac;
    border-radius: 100%;
    display: inline-block;
    animation: slide 1s infinite;
  }
  .dot:nth-child(1) {
    animation-delay: 0.1s;
    background: #32aacc;
  }
  .dot:nth-child(2) {
    animation-delay: 0.2s;
    background: #64aacc;
  }
  .dot:nth-child(3) {
    animation-delay: 0.3s;
    background: #96aacc;
  }
  .dot:nth-child(4) {
    animation-delay: 0.4s;
    background: #c8aacc;
  }
  .dot:nth-child(5) {
    animation-delay: 0.5s;
    background: #faaacc;
  }
  @keyframes slide {
    0% {
      transform: scale(1);
    }
    50% {
      opacity: 0.3;
      transform: scale(2);
    }
    100% {
      transform: scale(1);
    }
  }



@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading {
    position: relative;
    border-radius: 50%;
    width: 21px;
    height: 20px;
    border: 4px solid rgba(255, 255, 255, 0.5);
    border-top-color: white;
    animation: spin 1s infinite linear;
}


  `, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.css"],"names":[],"mappings":"EAAE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EAqCA;IACE;MACE,mBAAmB;IACrB;IACA;MACE,YAAY;MACZ,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;EACF;;;;AAIF;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kCAAkC;AACtC","sourcesContent":["  .loader {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 200;\n  }\n  .dot {\n    width: 24px;\n    height: 24px;\n    background: #3ac;\n    border-radius: 100%;\n    display: inline-block;\n    animation: slide 1s infinite;\n  }\n  .dot:nth-child(1) {\n    animation-delay: 0.1s;\n    background: #32aacc;\n  }\n  .dot:nth-child(2) {\n    animation-delay: 0.2s;\n    background: #64aacc;\n  }\n  .dot:nth-child(3) {\n    animation-delay: 0.3s;\n    background: #96aacc;\n  }\n  .dot:nth-child(4) {\n    animation-delay: 0.4s;\n    background: #c8aacc;\n  }\n  .dot:nth-child(5) {\n    animation-delay: 0.5s;\n    background: #faaacc;\n  }\n  @-moz-keyframes slide {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      opacity: 0.3;\n      transform: scale(2);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  @-webkit-keyframes slide {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      opacity: 0.3;\n      transform: scale(2);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  @-o-keyframes slide {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      opacity: 0.3;\n      transform: scale(2);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  @keyframes slide {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      opacity: 0.3;\n      transform: scale(2);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n\n\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading {\n    position: relative;\n    border-radius: 50%;\n    width: 21px;\n    height: 20px;\n    border: 4px solid rgba(255, 255, 255, 0.5);\n    border-top-color: white;\n    animation: spin 1s infinite linear;\n}\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
